import {
  globalConfig,
  packageConfig,
  lxConfig,
  vrConfig,
  carConfig,
  hotelConfig,
  flightConfig,
  thirdPartyPackageConfig,
  cruiseConfig,
  MultiLOBWizardConfig
} from "stores/wizard/config";

export class ConfigBuilder {
  private siteid: number;
  private configBySiteID = {
    default: {
      global: { ...globalConfig },
      package: { ...packageConfig },
      lx: { ...lxConfig },
      vr: { ...vrConfig },
      car: { ...carConfig },
      hotel: { ...hotelConfig },
      thirdPartyPackage: { ...thirdPartyPackageConfig },
      cruise: { ...cruiseConfig },
      flight: { ...flightConfig }
    },
    4: {
      global: { ...globalConfig },
      package: { ...packageConfig },
      lx: { ...lxConfig },
      vr: { ...vrConfig },
      car: { ...carConfig },
      hotel: { ...hotelConfig },
      thirdPartyPackage: { ...thirdPartyPackageConfig },
      cruise: { ...cruiseConfig },
      flight: { ...flightConfig }
    }
  };

  constructor(siteid: number) {
    this.siteid = siteid;
  }

  public build(): MultiLOBWizardConfig {
    if (this.configBySiteID[this.siteid]) {
      return this.configBySiteID[this.siteid];
    } else {
      return this.configBySiteID.default;
    }
  }
}
